// Wortlaute der Erklärung „Materialien“. Regeln für jeden Text: siehe ../help.js.
// Die Namen der Reiter und Felder stehen so, wie die Materialseite sie zeigt (../material.js).
// Zwillingsdatei: help/machines.js. Was hier geändert wird, gehört fast immer auch dorthin.
export default {
  title: "Materialien",
  // Kurznamen der Seiten, für die Kopfzeile, die Zeitleiste und "Weiter zu …".
  section: {
    MaterialOverview: "Übersicht",
    MaterialDetail: "Material",
    CustomerDetail: "Kundenpreise",
    PacketDetail: "Paket",
    ProjectDetail: "Projekt",
    ProjectCostsForOne: "Projektkosten",
  },
  // Die Seiten außerhalb des Katalogs, in denen ein Material wirkt. In der Zeitleiste abgesetzt.
  related: "Zusammenhänge",
  step: {
    list: {
      text: "Hier steht der Materialkatalog Ihres Betriebs. Ein Klick auf eine Zeile öffnet das Material.",
    },
    row: {
      text: "Die Zeile zeigt Bezeichnung, Einkaufspreis je Einheit und wann das Material zuletzt geändert wurde.",
    },
    create: {
      text: "Neu anlegen bietet beides an: Neues Material erstellen öffnet das leere Formular. Es braucht Bezeichnung und Einheit.",
    },
    "kind-filter": {
      text: "Materialien und Pakete stehen in einer Tabelle, der Filter darüber zeigt nur eines von beiden. Ein Paket bündelt mehrere Materialien für Projekt und Kunde.",
    },
    head: {
      text: "Der Kopf trägt Symbol und Namen des Materials. Rechts stehen die Aktionen zu diesem Datensatz.",
    },
    "action-duplicate": {
      text: "Duplizieren öffnet ein neues Material mit denselben Angaben und Preisen. Sie ändern nur, was anders ist, und speichern.",
    },
    "action-packet": {
      text: "Paket daraus erstellen legt ein neues Paket an. Dieses Material steht darin schon als erste Position.",
    },
    tabs: {
      text: "Drei Reiter teilen die Seite auf. Welcher Reiter offen ist, steht in der Adresse der Seite.",
    },
    base: {
      text: "Bezeichnung und Einheit sind die Stammdaten. Die Einheit rechnet in Projekten und Paketen mit, auch bei schon erfassten Mengen.",
    },
    purchase: {
      text: "Der Einkaufspreis gilt je Einheit. Wer bei verschiedenen Lieferanten unterschiedlich viel zahlt, legt mehrere Einkaufspreise mit Bezeichnung an; einer davon ist der Standard. Jeder Preis wählt seine eigene Währung, ein Projekt rechnet nur mit dem Preis in seiner Währung.",
    },
    note: {
      text: "Die Notiz ist für den internen Hinweis. Sie gehört zum Material und nicht zu einem einzelnen Projekt.",
    },
    files: {
      text: "In die Dateiablage legen Sie Datenblätter und Prüfberichte. Ein Ablaufdatum färbt sich, sobald es näher kommt.",
    },
    activity: {
      text: "Das Protokoll zeigt, wo dieses Material verwendet wird, und darunter jede Änderung mit Tag und Person.",
    },
    save: {
      text: "Speichern schreibt alle Reiter auf einmal. Ein Reiter mit einem Fehler wird dabei nach vorn geholt.",
    },
    again: {
      text: "Diese Schaltfläche steht auf jeder Seite mit Erklärung. Ein Klick startet sie erneut.",
    },
    // Zusammenhänge: was das Material außerhalb des Katalogs bewirkt.
    "customer-price": {
      text: "Für einen Kunden hinterlegen Sie einen eigenen Verkaufspreis, fest oder als Zuschlag auf den Einkaufspreis von hier.",
    },
    "packet-items": {
      text: "Ein Paket bündelt mehrere Materialien. Ein Projekt oder ein Kunde übernimmt sie damit in einem Schritt.",
    },
    "project-materials": {
      text: "Das Projekt übernimmt die Einkaufspreise beim Hinzufügen und führt sie selbst weiter. Die Projektkosten rechnen Menge mal dem Einkaufspreis, der beim Buchen gewählt und festgeschrieben wurde.",
    },
    "project-report": {
      text: "Gebucht wird das Material im Reiter Materialien [[hwr:eines/einer/eines]] [[hwr.gen]], mit einer Menge je Tag. Zur Auswahl steht dort nur, was im Projekt hinterlegt ist.",
    },
    "project-costs": {
      text: "Die Kostenstruktur des Projekts zeigt, welcher Anteil der Kosten auf Material entfällt. Bewertet wird jede gebuchte Menge mit dem Einkaufspreis, der beim Speichern des Berichts festgeschrieben wurde.",
    },
  },
}
